export const profilConstants = {
    GET_REQUEST: 'PROFIL_GET_REQUEST',
    GET_SUCCESS: 'PROFIL_GET_SUCCESS',
    GET_FAILURE: 'PROFIL_GET_FAILURE',
    GET_FAILURE_DONE: 'PROFIL_GET_FAILURE_DONE',
}